import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import Uploader from 'lib/designSystem/Uploader';
import React from 'react';

const UploadDialog = (props: any) => {
  const {
    openUploadFile,
    setOpenUploadFile,
    handleFileChange,
    uploadedFileName,
    setUploadedFileName,
    handleUploadFile,
  } = props;

  return (
    <Dialog open={openUploadFile} onClose={() => setOpenUploadFile(false)}>
      <DialogTitle>Subir documento</DialogTitle>
      <DialogContent>
        <Uploader
          buttonText="Subir documento"
          handleFileChange={handleFileChange}
          uploadedFileName={uploadedFileName}
          setUploadedFileName={setUploadedFileName}
          accept="*/*"
        />
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={() => setOpenUploadFile(false)}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleUploadFile} color="primary">
          Subir
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDialog;
